// extracted by mini-css-extract-plugin
export var arrows = "_89-6";
export var decrementer = "_89-a";
export var disabled = "_89-4";
export var error = "_89-1";
export var hiddenText = "_89-b";
export var incrementer = "_89-9";
export var input = "_89-8";
export var inputWrapper = "_89-0";
export var leadingIcon = "_89-c";
export var readonly = "_89-3";
export var regular = "_89-7";
export var small = "_89-5";
export var warning = "_89-2";